import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const createOrder = createAsyncThunk('createOrder/createOrder', async (data) => {
    const { plan_id, sid, coupon_name,order_type } = data;
    try {
        const res = await axios({
            method: 'POST',
            url: process.env.REACT_APP_API_URL + `create_order`,
            data: {
                plan_id: plan_id,
                sid: sid,
                user_order_type: order_type,
                coupon_name: coupon_name
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

